'use client';

import Image from '@src/components/atoms/safe-image';
import { useRouter } from 'next/navigation';

import One21 from '@public/png/one21-white.png';
import IRichie from '@public/png/i-richie.png';
import Century21 from '@public/png/century21-gold.png';
import BCA from '@public/png/icon-bca-color.png';
import BNI from '@public/png/icon-bni-color.png';
import BRI from '@public/png/icon-bri-color.png';
import BSI from '@public/png/icon-bsi-color.png';
import Mandiri from '@public/png/icon-mandiri-color.png';
import Danamon from '@public/png/icon-danamon-color.png';
import CIMB from '@public/png/icon-cimb-color.png';
import Maybank from '@public/png/icon-maybank-color.png';
import Panin from '@public/png/icon-panin-color.png';

import useGlobalCtx from '@src/context/global-ctx';
import useWhatsappMessage from '@src/hooks/useWhatsapp';

const phone = '+6285692588739';

const Footer = () => {
  const router = useRouter();
  const { companyDetails } = useGlobalCtx();
  const { sendMessage } = useWhatsappMessage();

  const handleSendMessage = (type = 'button') => {
    if (type === 'anchor') {
      return sendMessage({
        phone: phone,
        type,
        message: 'Hi Century 21 Indonesia',
      });
    }

    sendMessage({
      phone: phone,
      type,
      message: 'Hi Century 21 Indonesia',
    });
  };

  const handleToHomepage = () => {
    router.push('/');
  };

  return (
    <div className="bg-[#252526]">
      <div
        className="w-full bg-[#252526] mx-auto px-[48px] max-w-[1440px] pt-6
      dd2-2xl:px-[24px] dd2-2xl:max-w-[unset]
      dd2-xl:pb-[100px] dd2-xl:pt-6"
      >
        <div
          className="flex items-end gap-[40px] 
         dd2-xl:flex-col-reverse dd2-xl:items-start"
        >
          <Image
            src={IRichie}
            alt="Mascot Richie"
            width={191}
            height={191}
            priority
            className="aspect-square cursor-pointer object-contain"
          />

          <div className="py-[40px]">
            <div className="flex items-start flex-wrap gap-x-[40px] gap-y-4">
              <div className="flex flex-col justify-start items-start">
                <Image
                  src={Century21}
                  alt="CENTURY 21 Indonesia"
                  width={190}
                  height={40}
                  className="cursor-pointer object-contain w-full max-w-[190px] h-[40px]"
                />
                <p className="text-[12px] text-[#BEAF87] font-satoshi-medium mb-2">
                  {companyDetails?.name ?? ''}
                </p>

                <div
                  className="flex items-center cursor-pointer"
                  onClick={handleToHomepage}
                >
                  <p className="text-[14px] font-satoshi text-[#FAFAFA] mr-1">
                    Powered by
                  </p>
                  <Image
                    src={One21}
                    alt="One21"
                    width={45}
                    height={12}
                    className="object-contain w-[44.769px] h-[12px]"
                  />
                </div>
              </div>
            </div>

            <div className="mt-[40px] flex items-center gap-[24px] mt-[40px] flex-wrap">
              <Image src={BCA} alt="BCA" width={80} height={40} className="object-contain" />
              <Image src={BNI} alt="BNI" width={80} height={40} className="object-contain" />
              <Image src={BRI} alt="BRI" width={80} height={40} className="object-contain" />
              <Image src={BSI} alt="BSI" width={80} height={40} className="object-contain" />
              <Image src={Mandiri} alt="Mandiri" width={80} height={40} className="object-contain" />
              <Image src={Danamon} alt="Danamon" width={80} height={40} className="object-contain" />
              <Image src={CIMB} alt="CIMB" width={80} height={40} className="object-contain" />
              <Image src={Maybank} alt="Maybank" width={80} height={40} className="object-contain" />
              <Image src={Panin} alt="Panin" width={80} height={40} className="object-contain" />
            </div>
          </div>
        </div>

        <div className="px-[48px] flex items-center justify-between border-t-[0.5px] py-[12px] border-solid border-[#686A68] 
         dd2-lg:block dd2-xl:px-0">
          <p className="text-[#FAFAFA] text-[14px] font-satoshi 
           dd2-lg:mb-2 dd2-lg:text-center">
            Designed by ONE21
          </p>
          <p className="text-[#FAFAFA] text-[14px] font-satoshi dd2-lg:text-center">
            © CENTURY 21 Indonesia. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
